import { useEffect } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { isPageReload } from "../utils/helpers/isPageReload";

function useNavigateAfterReload(navFn = null) {
  const history = useHistory();

  useEffect(() => {
    if (isPageReload()) {
      if (typeof navFn === "function") {
        navFn();
      } else {
        history.goBack();
      }

      sessionStorage.removeItem("isReload");
    } else {
      sessionStorage.removeItem("isReload");
    }

    const handleBeforeUnload = () => {
      sessionStorage.setItem("isReload", "true");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, []);
}

export { useNavigateAfterReload };
